import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {SegmentInfluencer} from '../../../../models/measure/report';
import { chartConfig } from '../../../app.constants';
import {PdfExportService} from '../../../services/export-pdf/pdf-export.service';
import {UserService} from '../../../services/user.service';

@Component({
  selector: 'influencer-overview-report',
  templateUrl: './influencer-overview-report.component.html',
  styleUrls: ['./influencer-overview-report.component.scss']
})
export class InfluencerOverviewReportComponent implements OnInit, AfterViewInit {
  static COMPONENT_NAME = 'InfluencerOverviewReportComponent';
  static DEFAULT_PIE_CENTER = [103, 45];
  @Input()
  segmentInfluencerOverview: SegmentInfluencer;
  @Input()
  pieChartCenter: number[];

  public nationalityChartSeriesColors = [];

  // use for nationality circle chart
  public nationalityCircleChartData = [];

  // use for nationality circle chart
  public platformLineChartData = [];

  constructor(private pdfService: PdfExportService,
              private userService: UserService) {
  }

  ngOnInit() {

    if (this.segmentInfluencerOverview) {
      // reverse the first color to make nationality first color different with platform chart
      const seriesColors = this.userService.chartColors.slice(); // clone array
      const firstColor = seriesColors.shift();
      seriesColors.push(firstColor);
      this.nationalityChartSeriesColors = seriesColors;

      this.nationalityCircleChartData = this.segmentInfluencerOverview.nationalities ?
        this.segmentInfluencerOverview.nationalities.map((nation) => ({
          name: nation.name,
          y: nation.percent
        })
      ) : [];
      this.platformLineChartData = this.segmentInfluencerOverview.platforms.map(platform => ({
          name: platform.name,
          y: platform.value
        })
      );
    }
  }

  ngAfterViewInit() {
    this.pdfService.incrementNumberReportReady(InfluencerOverviewReportComponent.COMPONENT_NAME);
  }

  get haveNoData() {
    if (!this.segmentInfluencerOverview) {
      return true;
    }
    return this.segmentInfluencerOverview.influencers.value === 0
      && (!this.segmentInfluencerOverview.nationalities || this.segmentInfluencerOverview.nationalities.length === 0)
      && this.segmentInfluencerOverview.platforms.length === 0;
  }

  getPieCenter() {
    return this.pieChartCenter = this.pieChartCenter ? this.pieChartCenter : InfluencerOverviewReportComponent.DEFAULT_PIE_CENTER;
  }

}



// WEBPACK FOOTER //
// ./src/app/main/measure/influencer-overview-report/influencer-overview-report.component.ts